import { GetStaticProps, GetStaticPaths } from 'next';
import { NextSeo } from 'next-seo';
import { getLanguagesPaths } from '~/utils/translate';
import { useAuth, withAuth } from '~/auth';
import { Translate, useTranslate } from '~/i18n';
import { Section } from '~/components/common/section';
import { SubmitLoader } from '~/components/common/loaders/submit';
import PayoutSection from '~/components/profile/payout.section';
import ProfileBanner from '~/components/profile/profile-banner';
import { SubMenuLayout } from '~/components/layout/submenu-page';
import { payout_links } from '~/components/layout/_links';

const PayoutPage = () => {
   const { translate } = useTranslate();
   const { userLoading } = useAuth();

   if (userLoading)
      return (
         <Section className="flex items-center justify-center py-6 my-5">
            <SubmitLoader />
         </Section>
      );

   return (
      <>
         <NextSeo
            title={translate({
               id: 'pageTitles:payout requests',
            })}
         />
         <SubMenuLayout
            menuItems={payout_links}
            title={<Translate id="payout:payouts title" />}
            description={<Translate id="payout:payouts subtitle" />}>
            <div>
               <div className="mt-6">
                  <ProfileBanner />
               </div>
               <PayoutSection />
            </div>
         </SubMenuLayout>
      </>
   );
};

export const getStaticPaths: GetStaticPaths = async () => {
   return {
      paths: getLanguagesPaths(),
      fallback: false,
   };
};

/******************************************************************
 *
 *  THIS PAGE IS USING STATIC SITE GENERATION
 *
 ******************************************************************/

export const getStaticProps: GetStaticProps = async () => {
   return {
      props: {},
   };
};

export default withAuth(PayoutPage);
